import React from 'react';

import { Box, useTheme } from '@chakra-ui/react';
import { Button, Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@mesh.ai/rabbit';

import { Refresh2 } from 'assets/assetsV1/iconComponents';

type Props = {
  isRefreshing: boolean;
  tooltipLabel?: string;
  handleRefresh?: () => void;
};

const AgGridRefreshButton = ({ isRefreshing, tooltipLabel = '', handleRefresh }: Props) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        // rotate the svg icon when isRefreshing is true and stop rotating when isRefreshing is false
        svg: {
          animation: `${isRefreshing ? 'spin 1s linear infinite' : 'none'}`,
        },
      }}
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Button size="icon" variant="text" onClick={handleRefresh}>
              <Refresh2 boxSize="24px" color={theme.colors.icon['1565BC']} />
            </Button>
          </TooltipTrigger>
          <TooltipPortal>
            {tooltipLabel && (
              <TooltipContent>
                <p>{tooltipLabel}</p>
              </TooltipContent>
            )}
          </TooltipPortal>
        </Tooltip>
      </TooltipProvider>
    </Box>
  );
};

export { AgGridRefreshButton };
